import { RPCs } from "../../../services/rpc.js";
import { SelectMultiOptionWrapper } from "../../../components/Select/SelectMultiOptionWrapper.js";
import { SelectAsyncRPC } from "../../../components/Select/SelectAsyncRPC.js";
import { ALL_CHECKPOINTS_ID } from "../constants.js";
import "react";
import { Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdBluetooth, MdNfc, MdOutlineQrCode } from "react-icons/md";
//#region src/modules/Locations/shared/SelectCheckpoint.tsx
var ADDITIONAL_OPTIONS = [{ id: ALL_CHECKPOINTS_ID }];
var ICON_TYPE_MAP = {
	ble: MdBluetooth,
	nfc: MdNfc,
	qr: MdOutlineQrCode
};
var SelectedSingle = ({ name, type }) => /* @__PURE__ */ jsxs("div", {
	className: "gap-x-xxs flex",
	children: [/* @__PURE__ */ jsx(Icon, {
		Icon: ICON_TYPE_MAP[type],
		size: "sm",
		color: "subtle"
	}), /* @__PURE__ */ jsx("div", {
		className: "truncate text-sm",
		children: name
	})]
});
var SelectedMulti = ({ name, type }, onRemove) => /* @__PURE__ */ jsx(SelectMultiOptionWrapper, {
	onRemove,
	children: /* @__PURE__ */ jsxs("div", {
		className: "gap-x-xxs flex",
		children: [/* @__PURE__ */ jsx(Icon, {
			Icon: ICON_TYPE_MAP[type],
			size: "sm",
			color: "subtle",
			className: "ml-xxs"
		}), /* @__PURE__ */ jsx("div", {
			className: "mr-xxs truncate text-sm",
			children: name
		})]
	})
});
var ListItem = ({ name, type }) => /* @__PURE__ */ jsxs("div", {
	className: "gap-x-xxs flex",
	children: [/* @__PURE__ */ jsx(Icon, {
		Icon: ICON_TYPE_MAP[type],
		size: "sm",
		color: "subtle"
	}), /* @__PURE__ */ jsx("div", {
		className: "truncate text-sm",
		children: name
	})]
});
var responseOptionsExtractor = (data) => data?.checkpoints;
var SelectCheckpoint = ({ allowAllOption, limit = 25, locationId, multi, value, ...atalayaSelectProps }) => {
	return /* @__PURE__ */ jsx(SelectAsyncRPC, {
		RenderListItem: ListItem,
		RenderSelectedMulti: SelectedMulti,
		RenderSelectedSingle: SelectedSingle,
		additionalOptions: allowAllOption ? ADDITIONAL_OPTIONS : void 0,
		args: { locationId },
		idProp: "id",
		limit,
		multi,
		optionLabelExtractor: ({ name }) => name,
		optionValueExtractor: ({ id }) => id,
		request: RPCs.Locations.GetLocationCheckpointsList.v1,
		responseOptionsExtractor,
		value,
		...atalayaSelectProps
	});
};
//#endregion
export { SelectCheckpoint };

//# sourceMappingURL=SelectCheckpoint.js.map